import React from 'react';
import { Outlet } from 'react-router-dom';
import Nav from './Nav';
import Footer from './Footer';

const MasterLayout = () => {
  const [mobileNavOpen, setMobileNavOpen] = React.useState(false);

  return (
    <>
      <div class="md:hidden">
        <Nav />
      </div>
      
      <div class="md:hidden">
        <Outlet />
      </div>
      
      <div class="md:hidden">
          <Footer />
      </div>

    </>
  );
};

export default MasterLayout;